import { getRequest } from 'features/common'
import settings from 'settings'
import { AuthRedirect } from '../types'

function baseUrl() {
  const { workspaceApiUrl } = settings
  return `${workspaceApiUrl}/auth-redirect`
}

export const checkMapAccessPermissions = async (mapId: string): Promise<AuthRedirect> => {
  return await getRequest(`${baseUrl()}/map/${mapId}`)
}

export const checkWorkflowAccessPermissions = async (workflowId: string): Promise<AuthRedirect> => {
  return await getRequest(`${baseUrl()}/workflow/${workflowId}`)
}
